import { TypeaheadSearchResult } from 'src/types/model';

export const getTypeaheadResultsFactory = (apiEndpoint: string, site?: 'eastasia' | 'main') => {
  return async function getTypeaheadResult(
    q: string,
    take: number
  ): Promise<{ results: TypeaheadSearchResult[] }> {
    const params = new URLSearchParams({
      q,
      take: take.toString(),
      site: site ?? 'main',
    });

    const response = await fetch(`${apiEndpoint}?${params.toString()}`);

    if (!response.ok) {
      throw new Error(`Failed to fetch typeahead results: ${response.statusText}`);
    }

    return response.json();
  };
};
